import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { ref, onValue, set, remove, off } from "firebase/database";
import AlertMessage from "../../AlertMessage";

const WeekdayForm = () => {
  const [schoolData, setSchoolData] = useState(null);
  const [selectedWeekday, setSelectedWeekday] = useState("");
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [periods, setPeriods] = useState([]);
  const [numberOfPeriods, setNumberOfPeriods] = useState(0);
  const [availablePeriods, setAvailablePeriods] = useState([]);
  const [newPeriod, setNewPeriod] = useState({
    periodName: "",
    startTime: "",
    endTime: "",
    className: "",
    division: "",
    teacher: "",
    subject: "",
  });

  const [sub, setSub] = useState([]); // Ensure this is an array of strings
  const [yearData, setYearData] = useState({});
  const [teachers, setTeachers] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [selectedYear, setSelectedYear] = useState("");
  const [general, setGeneral] = useState([]);
  const [combinedSubjects, setCombinedSubjects] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const weekdays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

    useEffect(() => {
      if (alertMessage) {
        setShowAlert(true);
        const timeoutId = setTimeout(() => {
          setShowAlert(false);
          setAlertMessage(""); 
        }, 3000);
        return () => clearTimeout(timeoutId);
      }
    }, [alertMessage]);
  
  // Fetch teachers from Firebase
  useEffect(() => {
    const teachRef = ref(db, `AttendanceData/${udiseNumber}/AttData/`);
    onValue(teachRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const teacherList = Object.keys(data).map(
          (empMobile) => data[empMobile].Name
        );
        setTeachers(teacherList);
      }
    });
  }, [selectedYear]);

  
  useEffect(() => {
    const fetchAllPeriods = () => {
      const periodsRef = ref(db, `schoolRegister/${udiseNumber}/periodAssign/`);
      const periodsMetaRef = ref(db, `schoolRegister/${udiseNumber}/periods/`);

      // Fetch periods
      onValue(periodsRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const allPeriods = [];
          Object.keys(data).forEach((className) => {
            Object.keys(data[className]).forEach((division) => {
              Object.keys(data[className][division]).forEach((teacher) => {
                Object.keys(data[className][division][teacher]).forEach(
                  (weekday) => {
                    Object.keys(
                      data[className][division][teacher][weekday]
                    ).forEach((periodName) => {
                      const periodData =
                        data[className][division][teacher][weekday][periodName];
                      allPeriods.push({
                        periodName,
                        startTime: periodData.startTime,
                        endTime: periodData.endTime,
                        className,
                        division,
                        teacher,
                        subject: periodData.subject,
                        weekday,
                      });
                    });
                  }
                );
              });
            });
          });
          setPeriods(allPeriods);
        } else {
          setPeriods([]);
        }
      });

      // Fetch the number of periods
      onValue(periodsMetaRef, (snapshot) => {
        const data = snapshot.val();
        if (data && data.numberOfPeriods) {
          setNumberOfPeriods(data.numberOfPeriods);
          const periodsArray = Array.from(
            { length: data.numberOfPeriods },
            (_, i) => (i + 1).toString()
          );
          setAvailablePeriods(periodsArray);
        }
      });
    };
    fetchAllPeriods();
  }, []);

  const handleWeekdayChange = (e) => setSelectedWeekday(e.target.value);

  const handleTeacherChange = (teacherName) => {
    setSelectedTeacher(teacherName);
    setNewPeriod({
      ...newPeriod,
      teacher: teacherName,
      className: "",
      division: "",
      subject: "",
    });

    // Fetch class, division, and subject options for the selected teacher
    fetchClassDivisionSubjectForTeacher(teacherName);
  };



  const fetchClassDivisionSubjectForTeacher = (teacherName) => {
    const teacherRefPath = schoolData === "icse" || schoolData === "cbse"
      ? `schoolRegister/${udiseNumber}/teacherAssign/icse/${teacherName}`
      : `schoolRegister/${udiseNumber}/teacherAssign/${teacherName}`;
  
    const teacherRef = ref(db, teacherRefPath);
    
    onValue(teacherRef, (snapshot) => {
      const teacherData = snapshot.val();
      if (teacherData) {
        const classList = Object.keys(teacherData);
        setClassOptions(classList);
  
        if (classList.length > 0) {
          const firstClass = classList[0];
          setNewPeriod((prev) => ({ ...prev, className: firstClass }));
  
          // Extract divisions directly
          const divisionList = Object.keys(teacherData[firstClass]);
          console.log("Divisions:", divisionList); // Correct way to log
  
          setDivisionOptions(divisionList);
         setSub(divisionList);
          if (schoolData === "icse" || schoolData === "cbse") {
            const firstDivision = divisionList[0];
            setNewPeriod((prev) => ({ ...prev, division: firstDivision }));
  
            // Extract subjects from the first division
            const subjectList = Object.keys(teacherData[firstClass][firstDivision]);
            console.log("Subjects:", subjectList);
            setSub(subjectList);

          }
        }
      }
    });
  };
  




  const fetchDivisionsForClass = (year, className) => {

    const divisionRef = ref(db, `schoolRegister/${udiseNumber}/studentData/`);
    onValue(divisionRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const divisionList = Object.keys(data)
          .filter(
            (serialNumber) => data[serialNumber].currentClass === className
          )
          .map((serialNumber) => data[serialNumber].division);
        const uniqueDivisionList = [...new Set(divisionList)];
        console.log(uniqueDivisionList);

        setDivisionOptions(uniqueDivisionList);
        console.log(uniqueDivisionList);
        if (uniqueDivisionList.length > 0) {
          setNewPeriod({ ...newPeriod, division: uniqueDivisionList[0] });
        }
      }
    });
  };

  const [selectedClass, setSelectedClass] = useState("");

  useEffect(() => {
    const classRef = ref(db, `schoolRegister/${udiseNumber}/studentData/`);
    onValue(classRef, (snapshot) => {
      const data = snapshot.val();

      if (data) {
        const classList = Object.keys(data).map(
          (serialNumber) => data[serialNumber].currentClass
        );
        const uniqueClassList = [...new Set(classList)];
        setClassOptions(uniqueClassList);
      }
    });
  }, [selectedYear]);

  useEffect(() => {
    const classRef = ref(db, `schoolRegister/${udiseNumber}/studentData/`);
    onValue(classRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const divisionList = Object.keys(data).map(
          (serialNumber) => data[serialNumber].division
        );
        const uniqueDivisionList = [...new Set(divisionList)];
        setDivisionOptions(uniqueDivisionList);
        console.log(uniqueDivisionList);
      }
    });
  }, [selectedYear]);

  const handleClassChange = (className) => {
    console.log(className);

    setSelectedClass(className);
    setNewPeriod({ ...newPeriod, className, subject: "" });
    setSubjectOptions([]);

    if (selectedYear) {
      const subjectsRef = ref(
        db,
        `schoolRegister/${udiseNumber}/subjectSequence/${selectedYear}/${className}`
      );
      onValue(subjectsRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const subjectsList = Object.keys(data).map((key) => data[key]);
          setSubjectOptions(subjectsList);
          console.log(subjectsList);
        } else {
          setSubjectOptions([]);
        }
      });
    }

    // Fetch subjects for the selected teacher, class, and division
    if (selectedTeacher) {
      const teacherRefPath = schoolData === "icse" || schoolData === "cbse"
        ? `schoolRegister/${udiseNumber}/teacherAssign/icse/${selectedTeacher}/${className}`
        : `schoolRegister/${udiseNumber}/teacherAssign/${selectedTeacher}/${className}`;

      const teacherRef = ref(db, teacherRefPath);
      onValue(teacherRef, (snapshot) => {
        const teacherData = snapshot.val();
        if (teacherData) {
          const divisionList = Object.keys(teacherData);
          setDivisionOptions(divisionList);
          console.log("Division List:", divisionList);

          if (divisionList.length > 0) {
            const firstDivision = divisionList[0];
            setNewPeriod((prev) => ({ ...prev, division: firstDivision }));

            const subjectList = Object.keys(teacherData[firstDivision]);
            setSubjectOptions(subjectList);
          }
        }
      });
    }
  };

  const fetchSubjectsForClass = (year, className) => {
    const subjectsRef = ref(
      db,
      `schoolRegister/${udiseNumber}/subjectSequence/${year}/${className}`
    );
    onValue(subjectsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const subjectsList = Object.keys(data).map((key) => data[key]);
        setSubjectOptions(subjectsList);
      } else {
        setSubjectOptions([]);
      }
    });
  };

  useEffect(() => {
    if (!udiseNumber || !selectedYear) return;
    let generalRef;
    if (schoolData) {
      generalRef = ref(
        db,
        `schoolRegister/${udiseNumber}/subjectSequence/${schoolData}/${selectedYear}`
      );
    } else {
      generalRef = ref(
        db,
        `schoolRegister/${udiseNumber}/subjectSequence/${selectedYear}`
      );
    }

    const listener = onValue(generalRef, (snapshot) => {
      const data = snapshot.val();

      if (data) {
        console.log("Fetched Data:", data);

        const extractSubjects = (obj) => {
          let subjects = [];
          Object.values(obj).forEach((value) => {
            if (typeof value === "object") {
              subjects = subjects.concat(extractSubjects(value));
            } else {
              subjects.push(value);
            }
          });
          return subjects;
        };

        const subjects = extractSubjects(data);
        setSub(subjects);
        console.log("Extracted Subjects:", subjects);
      }
    });

    // Cleanup: Unsubscribe from Firebase listener
    return () => {
      off(generalRef, "value", listener);
    };
  }, [udiseNumber, selectedYear, schoolData]);

  const handleYearChange = (year) => {
    setSelectedYear(year);
    setNewPeriod({ className: "", division: "", subject: "" });
    setSubjectOptions([]);
    setYearData({});
    setClassOptions([]);
    setDivisionOptions([]);
    setPeriods([]);
    setCombinedSubjects([]);

    if (year) {
      let refPath;
      if (schoolData === "icse" || schoolData === "cbse") {
        refPath = `schoolRegister/${udiseNumber}/subjectSequence/icse/${year}`;
      } else {
        refPath = `schoolRegister/${udiseNumber}/subjectSequence/${year}`;
      }

      const yearRef = ref(db, refPath);

      onValue(yearRef, (snapshot) => {
        if (snapshot.exists()) {
          const yearData = snapshot.val();
          setYearData(yearData);
          console.log("Year Data:", yearData);


          const classList = Object.keys(yearData);
          setClassOptions(classList);

          if (classList.length > 0) {
            const firstClass = classList[0];
            setNewPeriod((prev) => ({ ...prev, className: firstClass }));

            const divisionList = Object.keys(yearData[firstClass]);
            setDivisionOptions(divisionList);
            // console.log("Division List:", divisionList);

            console.log("Division List:", divisionList);

            if (divisionList.length > 0) {
              const firstDivision = divisionList[0];
              setNewPeriod((prev) => ({ ...prev, division: firstDivision }));
              console.log("First Division:", firstDivision);

              const subjectList = Object.values(yearData[firstClass]);
              setSub(
                subjectList.map((subject) =>
                  typeof subject === "object" ? subject : subject
                )
              );
            }
          }

          // Fetch and set subjects when board type is not "icse"
          if (schoolData !== "icse" && schoolData !== "cbse") {
            const allSubjects = [];
            Object.values(yearData).forEach((classData) => {
              Object.values(classData).forEach((subject) => {
                if (typeof subject === "object") {
                  allSubjects.push(...Object.values(subject));
                } else {
                  allSubjects.push(subject);
                }
              });
            });
            setSub(allSubjects);
          }
        }
      });
    }
  };

  useEffect(() => {
    if (!udiseNumber) return; // Prevent running if udiseNumber is undefined/null

    const icseRef = ref(db, `schoolRegister/${udiseNumber}/schoolData`);
    const unsubscribe = onValue(icseRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setSchoolData(data.boardType);
        console.log("Board Type:", data.boardType);
      }
    });

    return () => unsubscribe(); // Cleanup function to remove listener
  }, [selectedYear]); // Dependency added

  const fetchAssignedData = () => {
    const assignedRefPath = schoolData === "icse" || schoolData === "cbse"
      ? `schoolRegister/${udiseNumber}/teacherAssign/icse`
      : `schoolRegister/${udiseNumber}/teacherAssign`;

    const assignedRef = ref(db, assignedRefPath);
    onValue(assignedRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const assignedData = [];
        Object.keys(data).forEach((teacher) => {
          Object.keys(data[teacher]).forEach((className) => {
            Object.keys(data[teacher][className]).forEach((division) => {
              Object.keys(data[teacher][className][division]).forEach((subject) => {
                assignedData.push({
                  teacher,
                  className,
                  division,
                  subject,
                });
              });
            });
          });
        });
        setCombinedSubjects(assignedData);
      }
    });
  };

  useEffect(() => {
    fetchAssignedData();
  }, [udiseNumber, schoolData]);

  const handleDivisionChange = (division) => {
    setNewPeriod({ ...newPeriod, division });
    const divisionRef = ref(db, `schoolRegister/${udiseNumber}/studentData/`);
    onValue(divisionRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const subjectList = Object.keys(data)
          .filter((serialNumber) => data[serialNumber].division === division)
          .map((serialNumber) => data[serialNumber].subject);
        setSubjectOptions(subjectList);
      } else {
        setSubjectOptions([]);
      }
    });
  };

  const handlePeriodChange = (field, value) =>
    setNewPeriod({ ...newPeriod, [field]: value });

  const handleNumberOfPeriodsChange = (e) => {
    const num = parseInt(e.target.value, 10);
    setNumberOfPeriods(num);

    // Generate available period names as numbers
    const periodsArray = Array.from({ length: num }, (_, i) =>
      (i + 1).toString()
    );
    setAvailablePeriods(periodsArray);
  };

  const handleSaveNumberOfPeriods = () => {
    const periodsRef = ref(db, `schoolRegister/${udiseNumber}/periods/`);
    set(periodsRef, { numberOfPeriods })
      .then(() => setAlertMessage("Number of periods saved successfully!"))
      .catch((error) =>
        console.error("Error saving number of periods:", error)
      );
  };


  const handleAddPeriod = () => {
    console.log("Attempting to add period with data:", newPeriod, selectedWeekday);
    if (
      newPeriod.periodName &&
      newPeriod.startTime &&
      newPeriod.endTime &&
      newPeriod.className &&
      ((schoolData !== "icse" && schoolData !== "cbse") || newPeriod.division) &&
      newPeriod.teacher &&
      newPeriod.subject
    ) {
      // Check for conflicts with existing periods for the same class/division
      const isDuplicate = periods.some(
        (period) =>
          period.weekday === selectedWeekday &&
          period.className === newPeriod.className &&
          ((schoolData === "icse" || schoolData === "cbse")? period.division === newPeriod.division : true) &&
          ((period.startTime === newPeriod.startTime && period.endTime === newPeriod.endTime) ||
            (newPeriod.startTime >= period.startTime && newPeriod.startTime < period.endTime) ||
            (newPeriod.endTime > period.startTime && newPeriod.endTime <= period.endTime))
      );
  
      if (isDuplicate) {
        setAlertMessage(
          "This period time conflicts with an existing period for the selected class and division."
        );
        return;
      }

      // Find if the teacher is already assigned to another class at the same time
      const conflictingPeriod = periods.find(
        (period) =>
          period.weekday === selectedWeekday &&
          period.teacher === newPeriod.teacher &&
          ((period.startTime === newPeriod.startTime && period.endTime === newPeriod.endTime) ||
            (newPeriod.startTime >= period.startTime && newPeriod.startTime < period.endTime) ||
            (newPeriod.endTime > period.startTime && newPeriod.endTime <= period.endTime))
      );

      if (conflictingPeriod) {
        setAlertMessage(
          `This teacher is already assigned to ${conflictingPeriod.className}${
            (schoolData === "icse") && conflictingPeriod.division !== "-" 
              ? ` (Division ${conflictingPeriod.division})` 
              : ''
          } from ${conflictingPeriod.startTime} to ${conflictingPeriod.endTime} on ${selectedWeekday}.`
        );
        return;
      }
  
      const weekdayRef = ref(
        db,
        `schoolRegister/${udiseNumber}/periodAssign/${newPeriod.className}/${(schoolData !== "icse" && schoolData !== "cbse") ? "-" : newPeriod.division}/${newPeriod.teacher}/${selectedWeekday}/${newPeriod.periodName}`
      );
  
      const periodData = {
        startTime: newPeriod.startTime,
        endTime: newPeriod.endTime,
        className: newPeriod.className,
        division: (schoolData !== "icse" && schoolData !== "cbse") ? "-" : newPeriod.division,
        teacher: newPeriod.teacher,
        subject: newPeriod.subject,
      };
  console.log("newPeriod",newPeriod);
  
      console.log("Adding period with data:", periodData);
  
      set(weekdayRef, periodData)
        .then(() => {
          setAlertMessage("Period added successfully!");
  
          setNewPeriod({
            periodName: "",
            startTime: "",
            endTime: "",
            className: "",
            division: "",
            teacher: "",
            subject: "",
          });
        })
        .catch((error) => {
          console.error("Error adding period:", error);
          setAlertMessage("Failed to add period. Please try again.");
        });
    } else {
      setAlertMessage("Please fill out all fields before adding a period.");
    }
  };


  const handleDeletePeriod = (period) => {
    if (!window.confirm("Are you sure you want to delete this period?")) return;
  
    const periodRef = ref(
      db,
      `schoolRegister/${udiseNumber}/periodAssign/${period.className}/${(schoolData !== "icse" && schoolData !== "cbse") ? "-" : period.division}/${period.teacher}/${period.weekday}/${period.periodName}`
    );

    remove(periodRef)
      .then(() => {
        setPeriods((prevPeriods) =>
          prevPeriods.filter(
            (period) =>
              !(period.periodName === period.periodName && period.weekday === period.weekday)
          )
        );
        setAlertMessage("Period deleted successfully!");
      })
      .catch((error) => {
        console.error("Error deleting period:", error);
        setAlertMessage("Failed to delete period. Please try again.");
      });
  };

  const handleResetForm = () => {
    if (!window.confirm("Are you sure you want to reset this form and table?"))
      return;

    setNewPeriod({
      periodName: "",
      startTime: "",
      endTime: "",
      className: "",
      division: "",
      teacher: "",
      subject: "",
    });
    setSelectedWeekday("");
    setSelectedTeacher("");
    setAvailablePeriods([]);
    setAlertMessage("Form and table reset successfully!");
  };

  const filteredPeriods = periods
  .filter(
    (period) =>
      (!selectedWeekday || period.weekday === selectedWeekday) &&
      (!selectedTeacher || period.teacher === selectedTeacher)
  )
  .sort((a, b) => {
  
    const weekdayComparison = weekdays.indexOf(a.weekday) - weekdays.indexOf(b.weekday);
    if (weekdayComparison !== 0) {
      return weekdayComparison; 
    }
    return a.periodName - b.periodName; 
  });

  const formatTime = (time24) => {
    if (!time24) return "";
    const [hours, minutes] = time24.split(":").map(Number);
    const suffix = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12;
    return `${hours12}:${minutes.toString().padStart(2, "0")} ${suffix}`;
  };

  const getYearOptions = () => {
    const currentYear = 2020;
    const years = [];

    for (let i = 0; i < 10; i++) {
      const year = currentYear + i;
      years.push(`${year}-${String(year + 1)}`);
    }
    return years;
  };

  const formatDivision = (division) => {
    return (schoolData !== "icse" && schoolData !== "cbse") ? "-" : division;
  };

  return (
    <div
      className="main-content-of-page"
      style={{ display: "flex" }}
    >
      <AlertMessage message={alertMessage} show={showAlert}/>
      <div className="card shadow w-100 p-3">
        <div className="card-body">
          <h3 className="card-title text-center mb-4">
            Period Assign Timetable
          </h3>

          <div
            className="mb-5"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center", marginRight:'20px'
              }}
            >
              <label htmlFor="number-periods" className="form-label">
                Number of Periods:
              </label>
              <input
                type="number"
                id="number-periods" style={{width:'130px'}}
                className="form-control "
                value={numberOfPeriods}
                onChange={handleNumberOfPeriodsChange}
              />
            </div>

            <div >
              <label
                style={{
                  fontWeight: "bold",
                }}
              >
                Year:
              </label>
              <select
                name="year"
                value={selectedYear}
                onChange={(e) => handleYearChange(e.target.value)}
                style={{
                  width: "140px",
                  padding: "5px",
                  borderRadius: "5px",
                  border: "1px solid #cdc3c3",
                }}
              >
                <option value="">Select a Year</option>
                {getYearOptions().map((year, index) => (
                  <option key={index} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginLeft: "15px" }}>
              <button
                className="btn btn-success"
                onClick={handleSaveNumberOfPeriods}
              >
                Save
              </button>
            </div>
          </div>
          
<div style={{boxShadow:"0px 4px 10px rgba(0, 0, 0, 0.3)", padding:'25px'}}>

          <div className="row mb-4 mt-4">
            <div className="col-md-6">
              <label htmlFor="weekday-select" className="form-label">
                Select a weekday:
              </label>
              <select
                id="weekday-select"
                value={selectedWeekday}
                onChange={handleWeekdayChange}
                className="form-select"
              >
                <option value="">-- Select Weekday --</option>
                {weekdays.map((day) => (
                  <option key={day} value={day}>
                    {day}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6">
              <label htmlFor="teacher-select" className="form-label">
                Select a teacher:
              </label>
              <select
                id="teacher-select"
                value={selectedTeacher}
                onChange={(e) => handleTeacherChange(e.target.value)}
                className="form-select"
              >
                <option value="">-- Select Teacher --</option>
                {teachers.map((teacher, index) => (
                  <option key={index} value={teacher}>
                    {teacher}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Period Input Form */}
          <div className="row mt-4">
            <div className="col-md-3">
              <label>Period Name</label>
              <select
                className="form-control"
                value={newPeriod.periodName}
                onChange={(e) =>
                  handlePeriodChange("periodName", e.target.value)
                }
              >
                <option value="">Select Period</option>
                {availablePeriods.map((period, index) => (
                  <option key={index} value={period}>
                    {period}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label>Start Time</label>
              <input
                type="time"
                className="form-control"
                value={newPeriod.startTime}
                onChange={(e) =>
                  handlePeriodChange("startTime", e.target.value)
                }
              />
            </div>

            <div className="col-md-3">
              <label>End Time</label>
              <input
                type="time"
                className="form-control"
                value={newPeriod.endTime}
                onChange={(e) => handlePeriodChange("endTime", e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <label>Class</label>
              <select
                className="form-control"
                value={newPeriod.className}
                onChange={(e) => handleClassChange(e.target.value)}
              >
                <option value="">Select Class</option>
                {Array.isArray(classOptions) && classOptions.length > 0 ? (
                  classOptions.map((classOption, index) => (
                    <option key={index} value={classOption}>
                      {classOption}
                    </option>
                  ))
                ) : (
                  <option>No classes available</option>
                )}
              </select>
            </div>
          </div>

          {/* Division and Subject Input */}
          <div className="row mt-4">
            <div className="col-md-3">
              <label>Division</label>
              <select
                className="form-control"
                value={newPeriod.division}
                onChange={(e) => handleDivisionChange(e.target.value)}
                disabled={schoolData !== "icse" && schoolData !== "cbse"}
              >
                <option value="">Select Division</option>
                {divisionOptions.map((division, index) => (
                  <option key={index} value={division}>
                    {division}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label>Subject</label>
              <select
                className="form-control"
                value={newPeriod.subject}
                onChange={(e) => handlePeriodChange("subject", e.target.value)}
              >
                <option value="">Select Subject</option>
                {Array.isArray(sub) && sub.length > 0 ? (
                  sub.map((subject, index) => (
                    <option key={index} value={subject}>
                      {subject}
                    </option>
                  ))
                ) : (
                  <option>No subjects available</option>
                )}
              </select>
            </div>

            <div
              className="col-md-6"
              style={{ display: "flex", gap: "15px", justifyContent: "start" }}
            >
              <button
                className="btn btn-primary mt-4 w-30 btn-md"
                onClick={handleAddPeriod}
              >
                Add Period
              </button>

              <button
                className="btn btn-danger mt-4 w-30 btn-md gap-4"
                onClick={handleResetForm}
              >
                Reset
              </button>
            </div>
          </div>
</div>
            <style jsx>{`
                .table th, .table td {
                  border:1px solid black;
                }
            `}</style>
            
          {filteredPeriods.length > 0 && (
            <div
              className="mt-5"
              style={{ overflowX: "auto" , paddingTop:'70px'}}
            >
              <h5 className="text-center">Assigned Periods</h5>
              <table
                className="table table-bordered table-hover"
                style={{ overflowX: "auto", display: "block", height: "280px" }}
              >
                <thead>
                  <tr>
                    <th>Weekday</th>
                    <th>Period Name</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Class</th>
                    <th>Division</th>
                    <th>Teacher</th>
                    <th>Subject</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPeriods.map((period, index) => (
                    <tr key={index}>
                      <td>{period.weekday}</td>
                      <td>{period.periodName}</td>
                      <td>{formatTime(period.startTime)}</td>
                      <td>{formatTime(period.endTime)}</td>
                      <td>{period.className}</td>
                      <td>{formatDivision(period.division)}</td>
                      <td>{period.teacher}</td>
                      <td>{period.subject}</td>
                      <td>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() =>
                            handleDeletePeriod(
                              period
                            )
                          }
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WeekdayForm;